// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import router from './router'
import localStorage from './core/local-storage'
import Toasted from 'vue-toasted'
import 'vue-googlemaps/dist/vue-googlemaps.css'
import AppView from './App'
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
// import {capitalize, toQueryString, labelCase, prettyBytes} from './filters'
import VeeValidate, { Validator } from 'vee-validate'
import VeeValidateEs from 'vee-validate/dist/locale/es'
import db from './core/pouchdb'
import VueOffline from 'vue-offline'

Vue.use(VueAxios, axios)

Vue.use(Toasted, {
  iconPack: 'fontawesome'
})

Vue.component('bounce-loader', BounceLoader)

Vue.use(VeeValidate)
Validator.localize('es', VeeValidateEs)

Vue.use(VueOffline)

Vue.config.productionTip = false

store.commit('SET_USER', localStorage.getUser())
store.commit('SYNC_API_DATA', {type: 'roles', items: localStorage.getKey('roles', true)})

db.init('simaapp-web')

/* eslint-disable no-new */
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js